import { useRef, useImperativeHandle, forwardRef, memo, useState } from 'react';
import styles from './FJAvatarAudioPlay.module.less';
import classNames from 'classnames';
import FJErrorIcon from '../../../../assets/svg/error.svg?react';
import FJPauseIcon from '../../../../assets/svg/pause.svg?react';
import FJPlayIcon from '../../../../assets/svg/play.svg?react';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJMessageStore from '../../../../store/FJMessageStore.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import { useEffect } from 'react';

const FJAvatarAudioPlay = (props, ref) => {
    const { audioUrl, imgUrl, className, style, playClassname } = props;
    const [isCoverError, setIsCoverError] = useState(false);
    const [isPlay, setIsPlay] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [useAudioUrl, setUseAudioUrl] = useState(audioUrl);
    const audioRef = useRef(null);
    const idRef = useRef(FJAudioPlayManager.createId());

    useEffect(() => {
        return () => {
            FJAudioPlayManager.delete(idRef.current);
        };
    }, []);

    useEffect(() => {
        setUseAudioUrl(audioUrl);
    }, [audioUrl]);

    useEffect(() => {
        setIsCoverError(false);
    }, [imgUrl]);

    useImperativeHandle(ref, () => ({
        changePlay: () => {
            _changePlay();
        },
    }));

    const _onCoverError = e => {
        setIsCoverError(true);
    };

    const _changePlay = e => {
        e?.stopPropagation();
        setIsPlay(!isPlay);
        if (isPlay) {
            pause();
        } else {
            if (isError) {
                setIsLoading(true);
                setUseAudioUrl(FJUtil.getReloadNewUrl(audioUrl));
            } else {
                play();
            }
        }
    };

    const play = () => {
        FJAudioPlayManager.add(idRef.current, { pause: pause });
        audioRef.current?.play();
        setIsPlay(true);
    };

    const pause = () => {
        if (audioRef.current) {
            audioRef.current?.pause();
        }
        audioRef.current = null;
        setIsPlay(false);
    };

    const _onEnded = () => {
        setIsPlay(false);
        pause();
    };

    const _onError = () => {
        setIsError(true);
        setIsLoading(false);
        if (isPlay) {
            setIsPlay(false);
            FJMessageStore.addMessage(FJLocalStore._('playback-failed-please-try-again'), 'error');
        }
    };

    const _onLoadedData = () => {
        setIsError(false);
        setIsLoading(false);
    };

    const _onLoadStart = () => {
        setIsLoading(true);
        setIsError(false);
        if (isPlay) {
            play();
        }
    };

    const _forbidEvent = e => {
        FJUtil.forbidEvent(e);
    };

    return (
        <div className={classNames(styles.box, className)} style={style}>
            <img className={styles.img} src={imgUrl} onError={_onCoverError} alt='' />
            {isCoverError && (
                <div className={classNames(styles.bk_mask, styles.cover_error)}>
                    <FJErrorIcon />
                </div>
            )}
            <div
                className={classNames(styles.play_box, playClassname)}
                onClick={_changePlay}
                onMouseDown={_forbidEvent}
            >
                {isLoading && <div className={styles.loading} />}
                {isPlay && <FJPauseIcon />}
                {!isPlay && <FJPlayIcon />}
                {isPlay && (
                    <audio
                        src={useAudioUrl}
                        ref={audioRef}
                        onEnded={_onEnded}
                        onError={_onError}
                        onLoadedData={_onLoadedData}
                        onLoadStart={_onLoadStart}
                        preload='metadata'
                    />
                )}
            </div>
        </div>
    );
};

export default memo(forwardRef(FJAvatarAudioPlay));
